import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';

import 'antd/dist/antd.css';
import './styles/main.less';

import Router from './router';

import configureStore from './store';

const history = createBrowserHistory();
// Set initial state for application
const initialState = {};
const store = configureStore(history, initialState);

ReactDOM.render(
  <Provider store={store}>
    <Router />
  </Provider>,
  document.getElementById('app-container')
);

if (module.hot) {
  module.hot.accept();
}
